export default __webpack_public_path__ + "007b2705c0a8f69dfdf6ea1bfa0341c9.png";